/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useState } from 'react';
import _ from 'lodash';

import JobListContext from './jobListContext';

import {defaultReactiveJob} from "./defaultContext";
import {defaultPlannedJob} from "./defaultContext";
import {defaultJobList} from "./defaultContext";

const JobListProvider = ({ children }) => {
  /**
   * App state / controls
   */
  const setAppJobDetails = ({
    currentPage,
    sortBy,
    openJobDetails,
    selectedReactiveJob,
    selectedPlannedJob,
    reactiveJobList,
    plannedJobList,
    filtersReactive,
    filtersSchedule,
  }) => {
    updateJobListDetails(prevState => {
      const newState = { ...prevState };

      return _.merge(newState, {
        currentPage,
        sortBy,
        openJobDetails,
        selectedReactiveJob,
        selectedPlannedJob,
        reactiveJobList,
        plannedJobList,
        filtersReactive,
        filtersSchedule,
      });
    });
  };

  const updateOpenJobDetails = (openJobDetails: boolean) => {
    updateJobListDetails(prevState => {
      const newState = { ...prevState };

      return _.merge(newState, {
        openJobDetails,
      });
    });
  };

  const updateReactiveJobList = (reactiveJobList: []) => {
    updateJobListDetails(prevState => {
      const newState = { ...prevState };

      return  _.assign(newState, {
        reactiveJobList,
      });
    });
  };

  const updateFilteredReactiveJobList = (reactiveJobList: []) => {
    updateJobListDetails(prevState => {
      const newState = { ...prevState };

      return _.assign(newState, {
        filteredReactiveJobList: reactiveJobList,
      });
    });
  };

  const updateFilteredPlannedJobList = (plannedJobList: []) => {
    updateJobListDetails(prevState => {
      const newState = { ...prevState };

      return _.assign(newState, {
        filteredPlannedJobList: plannedJobList,
      });
    })
  };

  const updatePlannedJobList = (plannedJobList: []) => {
    updateJobListDetails(prevState => {
      const newState = { ...prevState };

      return _.assign(newState, {
        plannedJobList,
      });
    });
  };

  const updateSort = (sortBy: string) => {
    updateJobListDetails(prevState => {
      const newState = { ...prevState };

      return _.merge(newState, {
        sortBy,
      });
    });
  };

  const updateReactiveFilters = (filtersReactive: {
    periodFilter: string;
    slaFilters: [];
    priortiyFilters: [];
    statusFilters: [];
    dateFilter: {};
  }) => {
    updateJobListDetails(prevState => {
      const newState = { ...prevState };

      return _.assign(newState, {
        filtersReactive,
      });
    });
  };

  const updatePlannedFilters = (filtersPlanned: {
    maintenanceFilter: '',
    statusFilter: '',
    buildingFilter: [],
    periodFilter: '',
    dateFilter: {},
  }) => {
    updateJobListDetails(prevState => {
      const newState = { ...prevState };

      return _.assign(newState, {
        filtersPlanned,
      });
    });
  };

  const clearFilters = () => {
    updateJobListDetails(prevState => {
      const newState = { ...prevState };
      const mergedState = _.assign(newState, {
        reactiveJobList: [],
        filtersReactive: {
          periodFilter: '',
          slaFilters: '',
          priortiyFilters: '',
          statusFilters: '',
          actionFilters: [],
          dateFilter: {},
        },
        filtersPlanned: {
          maintenanceFilter: '',
          statusFilter: '',
          buildingFilter: [],
          dateFilter: {},
          periodFilter: '',
        },
        sortBy: '',
      });

      return mergedState;
    });
  };

  const clearSelectedReactiveJob = () => {
    updateJobListDetails(prevState => {
      const newState = {...prevState};

      return {
        ...newState,
        selectedReactiveJob: {
          Action: '',
          Address: '',
          AddressName: '',
          CallDescription: 'Please select a job',
          CallNo: '',
          CallerName: '',
          CallerPhoneNo: '',
          CallerReference: '',
          CompletedDatetime: '',
          ContractNotes: '',
          ContractNo: '',
          CriticalStatus: '4',
          CustomerCode: '',
          CustomerName: '',
          CustomerReference: '',
          EngineerName: '',
          FaultNotes: '',
          GeneralNotes: '',
          Priority: '',
          PriorityCode: '',
          NumberEngineers: 0,
          OnsiteReqdDatetime: '',
          Operator: '',
          ReceivedDatetime: '',
          RequiredDatetime: '',
          RepairNotes: '',
          RequiredDate: '',
          SerialNo: '',
          SLA: 'upcoming',
          SLAOnsite: 'upcoming',
          SLAComplete: 'upcoming',
          SLACompleteActual: '',
          SLACompleteActualTime: '',
          SLACompleteEstimated: '',
          SLACompleteEstimatedTime: '',
          SLAOnsiteActual: '',
          SLAOnsiteActualTime: '',
          SLAOnsiteEstimated: '',
          SLAOnsiteEstimatedTime: '',
          SLAOnsiteEstimatedDateTime: '',
          SLAOnsiteActualDateTime: '',
          SLACompleteEstimatedDateTime: '',
          SLACompleteActualDateTime: '',
          SOOrderNo: '',
          Status: '',
          StatusCode: '',
          TypeCode: '',
          CallLocations: {
            CallLocation: {
              CallNo: '',
              ContractNo: '',
              LocationCode: '',
              LocationDesc: ''
            }
          },
          InvoiceNo: '',
          InvoiceDate: '',
          OrderedAmountIncTax: 0.0,
          OrderedAmountExTax: 0.0,
          TotalShippedTax: 0.0,
          TotalTax: 0.0,
        },
      };
    });
  };

  const clearSelectedPlannedJob = () => {
    updateJobListDetails(prevState => {
      const newState = {...prevState};

      return _.assign(newState, {
        selectedPlannedJob: {
          CUSTREF1: '',
          CUSTREF2: '',
          MODEL: '',
          VENDOR: '',
          YEARMAN: '',
          CallNo: 0,
          CallUnitSequence: 0,
          ContractNo: '',
          ContractSequenceNo: 0,
          ContractSiteDesc: '',
          CustomerCode: '',
          CustomerName: '',
          EngineerCode: '',
          EngineerName: '',
          InvoicedToDate: '',
          ItemCode: '',
          ItemDescription: 'Please select a job',
          MakeCode: '',
          Make: '',
          PMCallNo: 0,
          PMCallType: 0,
          PMEstHours: 0,
          Qty: '',
          Rate: 0,
          Reason: '',
          ReasonCode: '',
          Reseller: '',
          Routine: '',
          RoutineCode: '',
          RoutineDueDate: '',
          RoutineProcedure: '',
          RoutineProcedureCode: '',
          RoutineProcedureTaskText: '',
          Run: '',
          RunDueDate: '',
          RunNumber: 0,
          RunSequence: 0,
          ScuUserOnlyNum1: 0,
          ScuUserOnlyNum2: 0,
          SerialFlag: '',
          SerialLocationText: '',
          SerialNo: '',
          SerialStatusCode: 0,
          ServiceCentre: '',
          ServiceCentreCode: '',
          ServiceNo: '',
          ServicedQty: 0,
          Status: '',
          StatusCode: '',
          UniqueSequence: 0,
          UnitLocation: '',
          UnitLocationCode: '',
          UnitQty: 0,
        },
      });
    });
  };

  const updatePlannedAttributes = (attributes: {
    AttributeID: string,
    Response: string,
    Variable: string,
  }[]) => {
    updateJobListDetails(prevState => {
      const newState = {...prevState};
      const selected = _.cloneDeep(newState.selectedPlannedJob);
      const keys = ["CUSTREF1", "CUSTREF2", "MODEL", "VENDOR", "YEARMAN"];

      for(let attribute of attributes) {
        if(keys.includes(attribute.AttributeID)) {
          selected[attribute.AttributeID] = attribute.Response;
        }
      }

      return _.assign(newState,{selectedPlannedJob: selected});
    })
  };

  const updateScheduleFilters = (scheduleFilter: {
    ItemDescription: {},
    ContractNo: {},
  }) => {
    updateJobListDetails(prevState => {

      const newState = {...prevState};

      return _.merge(newState, {
        filtersSchedule:  scheduleFilter,
      });
    })
  };

  const deleteAllJobInfo = () => {
    updateJobListDetails(prevState => {
      const newState = {...prevState}

      return _.assign(newState,defaultJobList);
    })
  };

  const jobListState = {
    currentPage: '',
    sortBy: '',
    openJobDetails: false,
    selectedReactiveJob: defaultReactiveJob,
    selectedPlannedJob: defaultPlannedJob,
    reactiveJobList: [],
    filteredReactiveJobList: [],
    plannedJobList: [],
    filteredPlannedJobList: [],
    filtersReactive: {
      periodFilter: '',
      slaFilters: '',
      priortiyFilters: '',
      statusFilters: '',
      buildingFilters: [],
      actionFilters: [],
      dateFilter: {},
    },
    filtersPlanned: {
      maintenanceFilter: '',
      statusFilter: '',
      periodFilter: '',
      dateFilter: {},
      buildingFilter: [],
    },
    filtersSchedule: {
      ItemDescription: {},
      ContractNo: {},
    },

    updateOpenJobDetails,
    updateReactiveJobList,
    updateFilteredReactiveJobList,
    updateFilteredPlannedJobList,
    updatePlannedJobList,
    setAppJobDetails,
    updateSort,
    updateReactiveFilters,
    updatePlannedFilters,
    clearFilters,
    clearSelectedReactiveJob,
    clearSelectedPlannedJob,
    updateScheduleFilters,
    updatePlannedAttributes,
    deleteAllJobInfo,
  };

  const [jobListDetails, updateJobListDetails] = useState(jobListState);

  return <JobListContext.Provider value={jobListDetails}>{children}</JobListContext.Provider>;
};

export default JobListProvider;
